module.exports = __webpack_public_path__ + "static/media/mail.b6a40e29.svg";